// TODO: Import React module
import * as React from 'react';

// TODO: Import MUI module
import { Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Pagination } from '@mui/material';

// TODO: Import MUI icon
import { CancelRounded } from '@mui/icons-material';

// TODO: Import context

// TODO: Import custom component
import { Context, Webservices } from '../Common/Context';
/*import { Text } from '../Common/Text';*/

const DialogPopup = () => {
    // TODO: Define useContext
    const context = React.useContext(Context);

    // TODO: Define variable
    const [content, setContent] = React.useState([]);
    const [idx, setIdx] = React.useState(0);

    // TODO: Define event
    React.useEffect(() => {
        const GetPopup = () => {
            (async () => {
                const formData = new FormData();
                formData.append('action', 'Home_GetPopup');
                fetch(Webservices, { method: 'POST', body: formData, })
                    .then((response) => response.json())
                    .then((result) => {
                        if (result.length > 0) {
                            setContent(result);
                            context.dispatchShowPopup({ type: 'dispatchValue', value: false });
                        }
                    })
                    .catch((error) => { console.error('Error:', error); });
            })();
        }
        if (context.showPopup) {
            GetPopup();
        }
    }, [context]);

    React.useEffect(() => {
        if (content.length === 0) {
            setIdx(0);
        } else if (idx > content.length - 1) {
            setIdx(content.length - 1);
        }
    }, [content.length, idx]);

    const handlePageChange = (event, page) => {
        setIdx(page - 1);
    }

    const handleClose = () => {
        setContent([]);
    }

    // TODO: Return component
    return (
        <Dialog
            fullWidth
            maxWidth="md"
            open={content.length > 0}
            onClose={handleClose}
        >
            {
                content.length > 0 &&
                <>
                    <DialogActions sx={{ justifyContent: 'space-between', pb: 0 }}>
                        <Pagination
                            color="primary"
                            count={content.length}
                            onChange={handlePageChange}
                            page={idx + 1}
                            size="small"
                        />
                        <IconButton onClick={handleClose} sx={{ p: 0 }}>
                            <CancelRounded />
                        </IconButton>
                    </DialogActions>
                    <DialogTitle sx={{ color: 'primary.main' }}>{content[idx].title}</DialogTitle>
                    <DialogContent dangerouslySetInnerHTML={{ __html: content[idx].content }}>
                    </DialogContent>
                </>
            }
        </Dialog>
    );
}
export default DialogPopup;